import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import styles from './App.styles';
import { IntlProvider } from 'react-intl';
import axios from 'axios';
import translations from './i18n/locales';
import KioskLayout from './components/Kiosk/KioskLayout';
import KioskPickupLayout from './components/KioskPickup/KioskPickupLayout';
import KioskVerifyMeLayout from './components/KioskVerifyMe/KioskVerifyMeLayout';
import KioskConfimPickupLayout from './components/KioskConfimPickup/KioskConfimPickupLayout';
import KioskSignatureMain from './components/KioskSignature/KioskSignatureMain';
import KioskConsultLayout from './components/KioskConsult/KioskConsultLayout';
import KioskFeedbackLayout from './components/KioskFeedback/KioskFeedbackLayout';
import KioskDoorLayout from './components/KioskDoor/KioskDoorLayout';
import KioskCollectIDLayout from './components/KioskCollenctID/KioskCollectIDLayout';
import KioskEnrollmentLayout from './components/KioskEnrollment/KioskEnrollmentLayout';
import AdminLoginLayout from './components/AdminLogin/AdminLoginLayout';
import PatientLoginLayout from './components/PatientLogin/PatientLoginLayout';
import AdminPanelLayout from './components/AdminPanel/AdminPanelLayout';
import AdminPanelStockLayout from './components/AdminPanelStock/AdminPanelStockLayout';
import AdminKioskVerifyLayout from './components/KioskVerify/AdminKioskVerifyLayout';
import AdminMaintenanceLayout from './components/AdminMaintenance/AdminMaintenanceLayout';
import AdminSettingLayout from './components/AdminSetting/AdminSettingLayout';
import LoginLayout from './components/Login/LoginLayout';
import KioskOptHrsMain from './components/KioskOptHrs/KioskOptHrsMain';
import { initialSettings } from './reducers/data';
import KioskWelcomeScreenLayout from './components/KioskWelcomeScreen/KioskWelcomeScreenLayout';
import KioskCheckinLayout from './components/KioskCheckin/KioskCheckinLayout';
import KioskNewPatientEnrollmentLayout from './components/KioskNewPateint/KioskNewPatientEnrollmentLayout';
import KioskNewPatientSearchResultLayout from './components/KioskNewPatientSearchResult/KioskNewPatientSearchResultLayout';
import KioskCurrentPatientSearchLayout from './components/KioskCurrentPatient/KioskCurrentPatientSearchLayout';
import KioskCurrentPatientSearchResultLayout from './components/KioskCurrentPatientSearchResult/KioskCurrentPatientSearchResultLayout';
import KioskPatientLoginLayout from './components/KioskPatientLogin/KioskPatientLoginLayout';
import KioskPatientViewRxLayout from './components/KioskPatientViewRx/KioskPatientViewRxLayout';
import KioskOrderItemLayout from './components/KioskOrderItem/KioskOrderItemLayout';
import KioskHealthandinformationLayout from './components/KioskHealthandinformation/KioskHealthandinformationLayout';
import KioskRefillRxLayout from './components/KioskRefillRx/KioskRefillRxLayout';
import KioskShopNowLayout from './components/KioskShopNow/KioskShopNowLayout';
import KioskProductListLayout from './components/KioskProductList/KioskProductListLayout';
import KioskGetKitLayout from './components/KioskGetKit/KioskGetKitLayout';
import KioskQuizPassLayout from './components/KioskQuizPass/KioskQuizPassLayout';
import KioskQuizTestLayout from './components/KioskQuizTest//KioskQuizTestLayout';
import KioskQuizEnrollmentLayout from './components/KioskQuizEnrollment/KioskQuizEnrollmentLayout';
import KioskCheckConfirmuserLayout from './components/KioskCheckConfirmuser/KioskCheckConfirmuserLayout';
import {
  startPolling,
  stopPolling,
  updatePollingStats,
  updateData,
  initialData
} from './api/common/actions';
import AdminRemoveLayout from './components/AdminRemove/AdminRemoveLayout';

//In wall Rear Stock

import RearStockAdminLoginLayout from './components/InWallRearStock/AdminLogin/AdminLoginLayout';
import RearStockAdminPanelLayout from './components/InWallRearStock/AdminPanel/AdminPanelLayout';
import RearStockAdminPanelStockLayout from './components/InWallRearStock/AdminPanelStock/AdminPanelStockLayout';
import RearStockAdminMaintenanceLayout from './components/InWallRearStock/AdminMaintenance/AdminMaintenanceLayout';
import RearStockAdminSettingLayout from './components/InWallRearStock/AdminSetting/AdminSettingLayout';
import RearStockAdminRemoveLayout from './components/InWallRearStock/AdminRemove/AdminRemoveLayout';
import RearStockAdminKioskVerifyLayout from './components/InWallRearStock/KioskVerify/AdminKioskVerifyLayout';
import { writeInitSettings, readSettings, openBin } from './helpers/board';

import { w3cwebsocket as W3CWebSocket } from 'websocket';
const client = new W3CWebSocket('wss://dev.socket.localbox.net/');

let FileObje = {
  boxId: '',
  dynamicDataSource: false,
  rearStock: false,
  IsActive: true,
  pickupType: '1',
  steps: [
    {
      step: 0,
      name: 'Touch to Start',
      value: true,
      prev: '',
      next: '',
      btnClick: 0,
      stepTitle: 0
    },
    {
      step: 1,
      name: 'Pick up Code Enter',
      value: true,
      prev: '/',
      next: '/KioskVerify',
      btnClick: 0,
      stepTitle: 1
    },
    {
      step: 2,
      name: 'DOB verification',
      value: true,
      prev: '/KioskPickupCode',
      next: '/KioskConfirmPickup',
      btnClick: 0,
      stepTitle: 2
    },
    {
      step: 3,
      name: 'Confirm Pick up items',
      value: true,
      prev: '/KioskVerify',
      next: '/KioskConsult',
      btnClick: 0,
      stepTitle: 3
    },
    {
      step: 4,
      name: 'Consult',
      value: true,
      prev: '/KioskConfirmPickup',
      next: '/KioskSignature',
      btnClick: 0,
      stepTitle: 4
    },
    {
      step: 5,
      name: 'Signature',
      value: true,
      prev: '/KioskConsult',
      next: '/KioskCheckConfirmuser', //Modified By Belani Jaimin
      btnClick: 0,
      stepTitle: 5
    },
    {
      step: 6,
      name: 'DL Capture',
      value: true,
      prev: '/KioskSignature',
      next: '/KioskCollectMedicines',
      btnClick: 0,
      stepTitle: 6
    },
    {
      step: 7,
      name: 'Collect your items',
      value: true,
      prev: '',
      next: '/KioskFeedback',
      btnClick: 0,
      stepTitle: 7
    },
    {
      step: 8,
      name: 'Survey',
      value: true,
      prev: '',
      next: '/',
      btnClick: 0,
      stepTitle: 8
    },
    {
      step: 9,
      name: 'Confirm Pickup Payment',
      value: true,
      prev: '/KioskVerify',
      next: '/KioskConsult',
      btnClick: 0,
      stepTitle: 9
    },
    {
      step: 10,
      name: 'View Current Rx',
      value: true,
      prev: '/KioskPatientViewRx',
      next: '/KioskConsult',
      btnClick: 0,
      stepTitle: 0
    }
  ],
  posWaitDuration: 3000,
  IsNDCVideoAllow: false,
  /*
    Added By : Belani Jaimin
    Description: Send payment request to ingenico device
    Note: The default URL is base url of kiosk-wrapper code configuration.
          When the ingenico device will be integrated, Need to change URL from
          "http://localhost:3006/" to "https://localsystem.paygateway.com:21113/RcmService.svc/Initialize?xl2Parameter="
          otherwise it will always return dummy payment response.
  */
  paymentBaseUrl: ''
};
class App extends React.Component {
  componentWillMount() {
    writeInitSettings(FileObje);
    if (localStorage.getItem('steps') === null) {
      localStorage.setItem('steps', JSON.stringify(FileObje.steps));
    }
    if (localStorage.getItem('paymentBaseUrl') === null) {
      localStorage.setItem('paymentBaseUrl', FileObje.paymentBaseUrl);
    }
    this.startPolling();
    // localStorage.setItem(
    //   'rearStock',
    //   false /*process.env.REACT_APP_REAR_STOCK*/
    // );
    this.kioskConnectWithWebsocket();
  }

  getBoxesData = () => {
    let boxId, dataSource;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      boxId = fileData ? fileData.boxId : '';
      dataSource = fileData ? fileData.dynamicDataSource : false;
      FileObje.steps =
        fileData && fileData.steps ? fileData.steps : FileObje.steps;
    } else {
      boxId = localStorage.getItem('boxId');
      dataSource = JSON.parse(localStorage.getItem('dynamicDataSource'));
      FileObje.steps =
        localStorage.getItem('steps') !== null &&
        localStorage.getItem('steps') !== undefined
          ? JSON.parse(localStorage.getItem('steps'))
          : FileObje.steps;
    }

    if (dataSource === false || dataSource === null) {
      this.props.initialData(initialSettings);
      return true;
    } else {
      if (boxId) {
        return axios.get(
          process.env.REACT_APP_BASEURL + 'getprescriptions/' + boxId
        );
      } else {
        return axios.get(
          process.env.REACT_APP_BASEURL + 'getprescriptions/' + null
        );
      }
    }
  };
  kioskConnectWithWebsocket() {
    let boxId = '';
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      boxId = fileData ? fileData.boxId : '';
    } else {
      boxId =
        localStorage.getItem('boxId') !== null
          ? localStorage.getItem('boxId')
          : '';
    }
    client.onopen = () => {
      console.log('WebSocket Client Connected');
    };
    client.onmessage = message => {
      let dataFromServer = JSON.parse(message.data);
      let boxdetail =
        dataFromServer &&
        dataFromServer.data &&
        dataFromServer.data.users &&
        dataFromServer.data.users[boxId.toUpperCase()];
      if (boxdetail !== undefined && boxdetail !== 'undefined') {
        const stateToChange = {};
        if (
          dataFromServer.type === 'PORTAL' &&
          boxdetail.command === 'OPEN-BIN'
        ) {
          // stateToChange.currentUsers = Object.values(dataFromServer.data.users);
          this.openBinFromConnect(boxdetail.bin, boxId.toUpperCase());
        } else if (dataFromServer.type === 'KIOSK') {
          // stateToChange.text = dataFromServer.data.editorContent || contentDefaultMessage;
        }
        // stateToChange.userActivity = dataFromServer.data.userActivity;
        this.setState({
          ...stateToChange
        });
      }
    };
    client.onerror = () => {
      console.log(`Client error`);
    };
    client.onclose = () => {
      console.log(`connection closed`);
    };
  }
  openBinFromConnect(bin, boxId) {
    openBin(bin);
    let command = 'OPEN-BIN-SUCCESS';
    let box_id = boxId;
    if (box_id.trim()) {
      const data = {
        command,
        bin,
        box_id
      };
      this.setState(
        {
          ...data
        },
        () => {
          client.send(
            JSON.stringify({
              ...data,
              type: 'KIOSK'
            })
          );
        }
      );
    }
  }
  getUpdatedBoxes = response => {
    if (response && response.data) {
      this.props.updateData(response.data);
      return true;
    }
    return false;
  };

  handleStatsChange = stats => {
    this.props.updatePollingStats(stats);
  };

  startPolling = () => {
    this.props.startPolling({
      asyncFetch: this.getBoxesData,
      callback: this.getUpdatedBoxes,
      onStatsChange: this.handleStatsChange,
      delay: 10,
      retryOnFailure: true,
      retryAfter: 5,
      stopAfterRetries: 50
    });
  };

  stopPolling = () => {
    this.props.updatePollingStats({});
    this.props.stopPolling();
  };

  render() {
    const { locale } = this.props;
    const localeKey = locale || 'en';
    const messages = translations[localeKey];

    return (
      <IntlProvider locale={localeKey} key={localeKey} messages={messages}>
        <div>
          <Switch>
            <Route path="/" exact component={KioskLayout} />
            <Route path="/KioskPickupCode" component={KioskPickupLayout} />
            <Route path="/KioskVerify" component={KioskVerifyMeLayout} />
            <Route
              path="/KioskConfirmPickup"
              component={KioskConfimPickupLayout}
            />
            <Route path="/KioskSignature" component={KioskSignatureMain} />
            <Route path="/KioskConsult" component={KioskConsultLayout} />
            <Route path="/KioskFeedback" component={KioskFeedbackLayout} />
            <Route path="/KioskCollectMedicines" component={KioskDoorLayout} />
            <Route path="/KioskConfirmUser" component={KioskCollectIDLayout} />
            <Route path="/KioskEnrollment" component={KioskEnrollmentLayout} />
            <Route path="/KioskOptHrs" component={KioskOptHrsMain} />
            <Route
              path="/KioskWelcomeScreen"
              component={KioskWelcomeScreenLayout}
            />
            <Route path="/KioskCheckin" component={KioskCheckinLayout} />
            <Route
              path="/KioskNewPatientEnrollment"
              component={KioskNewPatientEnrollmentLayout}
            />
            <Route
              path="/KioskCurrentPatientSearch"
              component={KioskCurrentPatientSearchLayout}
            />
            <Route
              path="/KioskCurrentPatientSearchResult"
              component={KioskCurrentPatientSearchResultLayout}
            />
            <Route
              path="/KioskNewPatientSearchResult"
              component={KioskNewPatientSearchResultLayout}
            />
            <Route
              path="/KioskPatientLogin"
              component={KioskPatientLoginLayout}
            />
            <Route
              path="/KioskPatientViewRx"
              component={KioskPatientViewRxLayout}
            />
            <Route
              path="/KioskHealthandinformation"
              component={KioskHealthandinformationLayout}
            />
            <Route path="/KioskGetKit" component={KioskGetKitLayout} />
            <Route path="/KioskRefillRx" component={KioskRefillRxLayout} />
            <Route path="/KioskShopNow" component={KioskShopNowLayout} />
            <Route
              path="/KioskProductList"
              component={KioskProductListLayout}
            />
            <Route path="/KioskQuizTest" component={KioskQuizTestLayout} />
            <Route path="/KioskQuizPass" component={KioskQuizPassLayout} />
            <Route
              path="/KioskQuizEnrollment"
              component={KioskQuizEnrollmentLayout}
            />
            <Route path="/KioskOrderItem" component={KioskOrderItemLayout} />
            <Route path="/AdminLogin" component={AdminLoginLayout} />
            <Route path="/PatientLogin" component={PatientLoginLayout} />
            <Route path="/AdminPanel" component={AdminPanelLayout} />
            <Route path="/login" component={LoginLayout} />
            <Route path="/AdminStock" component={AdminPanelStockLayout} />
            <Route
              path="/AdminKioskVerify"
              component={AdminKioskVerifyLayout}
            />
            <Route
              path="/AdminMaintenance"
              component={AdminMaintenanceLayout}
            />
            <Route path="/AdminSettings" component={AdminSettingLayout} />
            <Route path="/AdminRemove" component={AdminRemoveLayout} />

            <Route
              path="/RearStock/AdminLogin"
              component={RearStockAdminLoginLayout}
            />
            <Route
              path="/RearStock/AdminStock"
              component={RearStockAdminPanelStockLayout}
            />
            <Route
              path="/RearStock/AdminPanel"
              component={RearStockAdminPanelLayout}
            />
            <Route
              path="/RearStock/AdminMaintenance"
              component={RearStockAdminMaintenanceLayout}
            />
            <Route
              path="/RearStock/AdminSettings"
              component={RearStockAdminSettingLayout}
            />
            <Route
              path="/RearStock/AdminRemove"
              component={RearStockAdminRemoveLayout}
            />
            <Route
              path="/RearStock/AdminKioskVerify"
              component={RearStockAdminKioskVerifyLayout}
            />
            <Route
              path="/KioskCheckConfirmuser"
              component={KioskCheckConfirmuserLayout}
            />
          </Switch>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = ({ box, pollingStats }) => ({
  box,
  ...pollingStats
});

const mapDispatchToProps = dispatch => ({
  startPolling: params => dispatch(startPolling(params)),
  stopPolling: () => dispatch(stopPolling()),
  updatePollingStats: stats => dispatch(updatePollingStats(stats)),
  updateData: box => dispatch(updateData(box)),
  initialData: box => dispatch(initialData(box))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(App));

// export default withStyles(styles, { withTheme: true })(App);
